import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

import { filterAccessorsListWithMatch } from '../../../utils';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';

@Component({
  selector: 'mwo-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements AfterViewInit {
  @Output() onSearchInput = new EventEmitter<any>();
  @Output() onEmptyValue = new EventEmitter<any>();
  @Input() placeholder = 'nav.search';
  @ViewChild('input', { static: false }) input: ElementRef;

  constructor(
  ) {
  }

  ngAfterViewInit() {
    fromEvent(this.input.nativeElement, 'keyup').pipe(
      map((event: any) => event.target.value),
      filter(value => value.length > 2 || !value.length),
      debounceTime(300),
      distinctUntilChanged(),
    ).subscribe(value => value
      ? this.onSearchInput.emit(filterAccessorsListWithMatch(value))
      : this.onEmptyValue.emit()
    );
  }
}
